import { memo as Memo, useRef, useEffect, useLayoutEffect } from 'react';
import { gsap } from 'gsap';

//* Styles
import MinTitleStyle from './style';

const MinTitle = Memo((props) => {
	//! Refs
	const ref = useRef(null);

	//! Anim timeline
	const tlRef = useRef(null);

	useLayoutEffect(() => {
		if (!ref.current) return;

		const ctx = gsap.context(() => {
			const kids = Array.from(ref.current.children);
			if (kids.length === 0) return;

			const special = kids[1] ?? kids[0];

			gsap.set(kids, { opacity: 0 });
			gsap.set(special, { fontStyle: 'normal' });

			tlRef.current = gsap
				.timeline({ paused: true, defaults: { overwrite: 'auto' } })
				.to(
					kids,
					{
						opacity: 1,
						duration: 0.001,
						stagger: 0.2,
						ease: 'none',
					},
					0
				)
				.set(
					special,
					{
						fontStyle: kids[1] ? 'italic' : 'normal',
					},
					0.42
				);
		}, ref);

		return () => ctx.revert();
	}, []);

	useEffect(() => {
		const tl = tlRef.current;
		const el = ref.current;
		if (!tl || !el) return;

		const kids = Array.from(el.children);
		const special = kids[1] ?? kids[0];

		if (props.active) {
			tl.play(0);
		} else {
			tl.pause(0);
			gsap.set(kids, { opacity: 0 });
			gsap.set(special, { fontStyle: 'normal' });
		}
	}, [props.active]);

	return (
		<MinTitleStyle
			ref={ref}
			className={`h2 font-poppins font-semi-bold title ${props.className || ''}`}>
			{props.title}
		</MinTitleStyle>
	);
});

export default MinTitle;
